import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

export function Pagination({ page, pages, total, onPageChange }) {
  if (pages <= 1) return null;

  const getVisiblePages = () => {
    const visible = [];
    const start = Math.max(1, page - 2);
    const end = Math.min(pages, page + 2);
    for (let i = start; i <= end; i++) visible.push(i);
    return visible;
  };

  return (
    <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-100" data-testid="pagination">
      <p className="text-xs text-slate-500">
        Showing <span className="font-semibold text-slate-700">{Math.min((page - 1) * 500 + 1, total)}-{Math.min(page * 500, total)}</span> of <span className="font-semibold text-slate-700">{total}</span>
      </p>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="icon" className="h-7 w-7" disabled={page <= 1} onClick={() => onPageChange(1)} data-testid="pagination-first">
          <ChevronsLeft className="w-3.5 h-3.5" />
        </Button>
        <Button variant="ghost" size="icon" className="h-7 w-7" disabled={page <= 1} onClick={() => onPageChange(page - 1)} data-testid="pagination-prev">
          <ChevronLeft className="w-3.5 h-3.5" />
        </Button>
        {getVisiblePages().map(p => (
          <Button
            key={p}
            variant={p === page ? 'default' : 'ghost'}
            size="sm"
            className={`h-7 w-7 text-xs ${p === page ? 'bg-slate-900 text-white hover:bg-slate-800' : ''}`}
            onClick={() => onPageChange(p)}
            data-testid={`pagination-page-${p}`}
          >
            {p}
          </Button>
        ))}
        <Button variant="ghost" size="icon" className="h-7 w-7" disabled={page >= pages} onClick={() => onPageChange(page + 1)} data-testid="pagination-next">
          <ChevronRight className="w-3.5 h-3.5" />
        </Button>
        <Button variant="ghost" size="icon" className="h-7 w-7" disabled={page >= pages} onClick={() => onPageChange(pages)} data-testid="pagination-last">
          <ChevronsRight className="w-3.5 h-3.5" />
        </Button>
      </div>
    </div>
  );
}
